import React from 'react';
import { Card, Nav, Row, Col, Badge } from 'react-bootstrap';
import moment from 'moment';
import TabDetalheTipo from './TabDetalheTipo';
import TabRastreamento from './TabRastreamento';
import TabRemessa from './TabRemessa';
import TabJustificativas from './TabJustificativas';

const fmt = (v) => v != null ? v : '-';
const fmtDate = (d) => d ? moment(d).format('DD/MM/YYYY') : '-';
const fmtMoney = (v) => v != null ? `R$ ${Number(v).toFixed(2).replace('.', ',')}` : '-';

const SubheaderItem = ({ label, value }) => (
  <Col xs={12} sm={6} md={4} lg={3} className="mb-2">
    <small className="text-muted d-block">{label}</small>
    <strong>{value}</strong>
  </Col>
);

const CardDetalheTitulo = ({
  titulo,
  abaAtiva,
  onMudarAba,
  movimentacoes,
  remessa,
  carregandoMovimentacoes,
  carregandoRemessa,
}) => {
  if (!titulo) return null;

  const tipoLabel = titulo.tipo_label || titulo.tipo || '-';
  const efetivacao = titulo.efetivacao === 'S' ? (
    <Badge variant="success">Efetivado</Badge>
  ) : (
    <Badge variant="danger">Não Efetivado</Badge>
  );

  return (
    <Card className="mb-3">
      <Card.Header>
        <strong>Detalhes do Título {titulo.codigo_titulo}</strong>
        {titulo.antecipacao_gravada && (
          <Badge variant="info" className="ml-2">Antecipação Gravada</Badge>
        )}
      </Card.Header>

      <Card.Body className="pb-0">
        <Row>
          <SubheaderItem label="Código" value={fmt(titulo.codigo_titulo)} />
          <SubheaderItem label="GE" value={titulo.apelido_grupo_empresa ? `${titulo.codigo_grupo_empresa} — ${titulo.apelido_grupo_empresa}` : fmt(titulo.codigo_grupo_empresa)} />
          <SubheaderItem label="Conta Cedente" value={fmt(titulo.conta_cedente)} />
          <SubheaderItem label="Conta Portador" value={fmt(titulo.conta_portador)} />
          <SubheaderItem label="Valor" value={fmtMoney(titulo.valor)} />
          <SubheaderItem label="Vencimento" value={fmtDate(titulo.data_vencimento)} />
          <SubheaderItem label="Data Baixa" value={fmtDate(titulo.data_baixa)} />
          <SubheaderItem label="Valor Baixa" value={fmtMoney(titulo.valor_baixa)} />
          <SubheaderItem label="CGC/CPF" value={fmt(titulo.cgc_cpf)} />
          <SubheaderItem label="Efetivação" value={efetivacao} />
          <SubheaderItem label="Tipo" value={`${tipoLabel} (${fmt(titulo.tipo)})`} />
          <SubheaderItem label="Prorrogações" value={fmt(titulo.prorrogacoes)} />
          <SubheaderItem label="Código Ativo" value={fmt(titulo.codigo_ativo)} />
          <SubheaderItem label="Código Proposta" value={fmt(titulo.codigo_proposta)} />
          <SubheaderItem label="Portador Baixa" value={fmt(titulo.conta_portador_baixa)} />
          <SubheaderItem label="Dias +" value={fmt(titulo.dias_mais)} />
          <SubheaderItem label="Nº Dias" value={fmt(titulo.numero_dias)} />
          <SubheaderItem label="Líquido" value={fmt(titulo.liquido)} />
        </Row>
      </Card.Body>

      <Nav
        variant="tabs"
        activeKey={abaAtiva}
        onSelect={onMudarAba}
        className="px-3 border-top"
      >
        <Nav.Item>
          <Nav.Link eventKey="detalhe">Detalhe do Tipo</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="rastreamento">Rastreamento</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="remessa">Remessa</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="justificativas">Justificativas</Nav.Link>
        </Nav.Item>
      </Nav>

      <Card.Body>
        {abaAtiva === 'detalhe' && <TabDetalheTipo titulo={titulo} />}
        {abaAtiva === 'rastreamento' && (
          <TabRastreamento movimentacoes={movimentacoes} carregando={carregandoMovimentacoes} />
        )}
        {abaAtiva === 'remessa' && (
          <TabRemessa remessa={remessa} carregando={carregandoRemessa} />
        )}
        {abaAtiva === 'justificativas' && (
          <TabJustificativas justificativas={titulo.justificativas} />
        )}
      </Card.Body>
    </Card>
  );
};

export default CardDetalheTitulo;
